import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import './ibcartao.css';
import Loading from "./components/loading"
import { sendEvent, CNPJ_API_URL, LEAD_API_URL } from './Config';
import LoadingSpinner from './components/LoadingSpinner';
import Footer from './components/Footer';

const EmailPDFSent = function () {
    const navigate = useNavigate();
    const enableNotificationsRef = useRef(null);
    const leadIdRef = useRef(localStorage.getItem("lead_id"));
    const [showModal, setShowModal] = useState(0);
    const hasLoadedFirstTime = useRef(false);
    const emailInputRef = useRef(false);
    const [cnpjData, setCNPJData] = useState(null);
    const [erroEmail, setErroEmail] = useState("");
    const email = useRef(localStorage.getItem("email"));
    const [emailFocus, setEmailFocus] = useState(false);

    useEffect(() => {
        sendEvent(leadIdRef.current ?? false, "email-pdf-sent");
    }, []);

    const handleFormSubmit = async (e) => {
        e.preventDefault();
    }


    return <>
        <div className='header flex items-center'>
            <div className='content flex items-center gap-x-4'>
                <div className='flex items-center w-auto border-r pr-4'>
                    <img src='/assets/img/logo-white.svg?t' className='logo' />
                </div>
                <div className='flex-1'>
                    <span className='subtitle'>Simulação de crédito BPF</span>
                </div>
            </div>
        </div>
        <div className="steps mt-5 flex gap-x-2">
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
            <div className='flex-1 check'></div>
        </div>
        <div className='container'>
            <form onSubmit={handleFormSubmit}>
                <div className='content mt-8'>
                    <h1>O resultado da sua simulação já foi enviado para o seu e-mail!</h1>
                    <p className='mt-6 separator-bottom pb-5'>
                        Verifique a sua caixa de entrada e, se necessário, a pasta de lixo eletrónico (spam).
                    </p>
                    <p className='caption mt-4'>O e-mail indicado foi <strong>{email.current}</strong>.</p>
                    <p className='caption mt-1'>
                        Se o e-mail estiver incorreto, <Link to="/onboarding/email">clique aqui</Link> para o corrigir.
                    </p>
                    <button className="primary w-full mt-6">
                        Fechar
                    </button>
                </div>
            </form>
        </div>
    </>
}

export default EmailPDFSent;